<template>
  <div class="loading">
    <div class="spinner-border" role="status"></div>
    <div class="mt-2">Lade...</div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.loading {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #ffeb94;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;

  .spinner-border {
    color: #ffcc4e;
  }
}
</style>
